import preparedReducer from './reducer';
import { getPerformance } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'performance';

export const selectors = state => state[SLICE_NAME];

export const actions = {
  getPerformance,
};
